export default {
  SET_CLAIMS: 'SET_CLAIMS',
  OPEN_CLAIM_DETAILS: 'OPEN_CLAIM_DETAILS',
  CLOSE_CLAIM_DETAILS: 'CLOSE_CLAIM_DETAILS',
  SET_CLAIMS_CLEANUP: 'SET_CLAIMS_CLEANUP',
  SET_CLAIMS_ERROR: 'SET_CLAIMS_ERROR',
  SET_CLAIM_DETAILS_SUCCESS:'SET_CLAIM_DETAILS_SUCCESS',
  SET_CLAIM_DETAILS_BEGIN:'SET_CLAIM_DETAILS_BEGIN',
  SET_CLAIM_DETAILS_ERROR:'SET_CLAIM_DETAILS_ERROR',
  SET_CLAIMS_YOU_OWE: 'SET_CLAIMS_YOU_OWE',
  SET_CLAIM_DETAIL_BENEFITS_BEGIN: 'SET_CLAIM_DETAIL_BENEFITS_BEGIN',
  SET_CLAIM_DETAIL_BENEFITS_SUCCESS: 'SET_CLAIM_DETAIL_BENEFITS_SUCCESS',
  SET_CLAIM_DETAIL_BENEFITS_ERROR: 'SET_CLAIM_DETAIL_BENEFITS_ERROR',
  SET_CLAIM_DETAIL_BENEFITS_CLEANUP: 'SET_CLAIM_DETAIL_BENEFITS_CLEANUP',
};
